// extracted by mini-css-extract-plugin
export default {"container":"paper_container__3TVpw"};